//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('resourcesStore/getResources', this.queries.faqs),
      this.$store.dispatch('pagesStore/getPage', 'faq')
    ])
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: {queries} }) => queries,
      pages: ({ pagesStore: {pages} }) => pages,
      faqs: ({ resourcesStore: {faqs} }) => faqs,
      loading: ({ resourcesStore: { loading } }) => loading
    }),
  },
  head() {
    return {
      title: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.title : 'Veelgestelde vragen | Info | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.title : 'Veelgestelde vragen | Info | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.title : 'Veelgestelde vragen | Info | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.description : 'Je vraagt ons het hemd van het lijf. Nu vinden we dat wel lekker, maar er blijft dan zo weinig tijd over om veel meer sexy dingen te doen. Daarom hebben we een aantal veel gestelde vragen voor je op een rijtje gezet.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.description : 'Je vraagt ons het hemd van het lijf. Nu vinden we dat wel lekker, maar er blijft dan zo weinig tijd over om veel meer sexy dingen te doen. Daarom hebben we een aantal veel gestelde vragen voor je op een rijtje gezet.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/veelgestelde-vragen' },
        { hid: 'keywords', name: 'keywords', content: this.pages.faq && this.pages.faq.seo ? this.pages.faq.seo.keywords : 'veelgestelde vragen, faq, vragen, vraag, vraag het ons' },
      ]
    }
  },
  data() {
    return {
      activeFaq: '',
    }
  },
  methods: {
    toggleQuestion(name) {
      if (this.activeFaq == name) {
        this.activeFaq = '';
      }else {
        this.activeFaq = name;
      }
    }
  }
}
